var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.0001 5.9852C0.999981 5.99354 0.999969 6.00188 1.00006 6.01022V18C1.00006 19.6523 2.34778 21 4.00006 21H20.0001C21.6523 21 23.0001 19.6523 23.0001 18V6.01402C23.0002 6.00256 23.0002 5.99109 23 5.97962C22.989 4.33665 21.6455 3 20.0001 3H4.00006C2.35271 3 1.00812 4.33968 1.0001 5.9852ZM3.10664 5.55395C3.27201 5.22693 3.6121 5 4.00006 5H20.0001C20.388 5 20.7281 5.22694 20.8935 5.55398L12.0001 11.7794L3.10664 5.55395ZM21.0001 7.9207V18C21.0001 18.5477 20.5478 19 20.0001 19H4.00006C3.45235 19 3.00006 18.5477 3.00006 18V7.92066L11.4266 13.8193C11.7709 14.0603 12.2292 14.0603 12.5735 13.8193L21.0001 7.9207Z",
    fill: "#979EBE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.1f75e6b570a11de558ea4d71bddd9185.svg";
export { ForwardRef as ReactComponent };